.chip {
    height: 24px !important;
    border: none;
    border-radius: 4px !important;
}

.chipLabel {
    padding-left: 8px !important;
    padding-right: 8px !important;
}

.selectedItem {
    background-color: #eeeeee;
}
